import React, { useState, useEffect, useRef } from "react";
import PermissionControlledCard from "../../../../common/PermissionControlledCard";

const TableTab = ({ tabs = [], onChange }) => {
  const [activeTab, setActiveTab] = useState(tabs[0]?.value || "");
  const scrollRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setShowLeftArrow(el.scrollLeft > 0);
    setShowRightArrow(el.scrollLeft + el.clientWidth < el.scrollWidth);
  };

  const scroll = (distance) => {
    scrollRef.current.scrollBy({ left: distance, behavior: "smooth" });
  };
  useEffect(() => {
    if (onChange) onChange(activeTab);
    handleScroll();
  }, [activeTab]);

  return (
    <div className="wrapper position-relative">
      <div className="button_grp d-flex overflow-auto hide-scrollbar"
        style={{ scrollSnapType: "x mandatory" }}
        ref={scrollRef}
        onScroll={handleScroll}>
        <ul>
          {tabs.map((tab,idx) => (
            <PermissionControlledCard
              key={idx}
              permission={tab.permission}
              colClass="tab-item tab-btn">
            <li
              key={tab.value}
              data-li={tab.value}
              className={`btn ${activeTab === tab.value ? "active" : ""}`}
              onClick={() => setActiveTab(tab.value)}
            >
              {tab.label}
            </li>
            </PermissionControlledCard>
          ))}
        </ul>
      </div>
            {showLeftArrow && (
        <button className="kpi-scroll-arrow left" onClick={() => scroll(-200)}>
          <i className="bi bi-chevron-left"></i>
        </button>
      )}

      {/* Right Arrow */}
      {showRightArrow && (
        <button className="kpi-scroll-arrow right" onClick={() => scroll(200)}>
          <i className="bi bi-chevron-right"></i>
        </button>
      )}

      {/* Blur overlay */}
      {showRightArrow && <div className="kpi-scroll-blur right-blur" />}
    </div>
  );
};

export default TableTab;
